import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Camera, Home, ArrowLeft } from "lucide-react";

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center space-y-8 max-w-sm w-full"
      >
        {/* Illustration */}
        <div className="relative mx-auto w-32 h-32">
          <div className="w-32 h-32 rounded-full bg-primary/10 flex items-center justify-center">
            <Camera className="w-14 h-14 text-primary/40" />
          </div>
          <div className="absolute -top-2 -right-2 w-10 h-10 rounded-full bg-accent/30 flex items-center justify-center font-display font-medium text-lg text-accent-foreground">
            ?
          </div>
        </div>

        {/* Text */}
        <div className="space-y-2">
          <h1 className="font-display text-6xl font-medium text-gradient">404</h1>
          <h2 className="font-display text-2xl font-medium text-foreground">Page introuvable</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Cette page n'existe pas ou a été déplacée. Retournez à l'accueil pour continuer.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate("/")}
            className="w-full h-12 rounded-2xl bg-primary text-primary-foreground font-semibold text-sm flex items-center justify-center gap-2 shadow-brand-sm hover:brightness-110 transition-all"
          >
            <Home className="w-4 h-4" /> Retour à l'accueil
          </button>
          <button
            onClick={() => navigate(-1)}
            className="w-full h-12 rounded-2xl border border-border bg-card font-semibold text-sm flex items-center justify-center gap-2 text-muted-foreground hover:border-primary/30 hover:text-foreground transition-all"
          >
            <ArrowLeft className="w-4 h-4" /> Page précédente
          </button>
        </div>
      </motion.div>
    </div>
  );
}